import { ApplicationConfig, APP_INITIALIZER, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { AuthService } from './shared/services/auth.service';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { provideNgxStripe } from 'ngx-stripe';
import { environment } from '../environments/environment'; // ✅ make sure this path is correct

function initAuth() {
  const auth = inject(AuthService);
  return () => auth.initFromStorage?.() ?? Promise.resolve();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideToastr({ positionClass: 'toast-bottom-right', preventDuplicates: true, timeOut: 4000 }),
     provideNgxStripe(environment.stripeApiKey),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: APP_INITIALIZER, useFactory: initAuth, multi: true }, // optional
  ],
};